<script setup lang="ts">
import { Permissions } from '@package/jwt/nuxt'
const { session } = useUserSession()

const { data: config } = useFetch('/api/config')

const enableUsers = computed(() =>
  session.value.permissions?.includes(Permissions.readUsersAll),
)

const items = computed(() => [
  [
    {
      label: 'Home',
      icon: 'i-ph-house',
      to: '/dashboard',
    },

    ...(enableUsers.value
      ? [
          {
            label: 'Users',
            icon: 'i-ph-users',
            to: '/users',
          },
          {
            label: 'Organizations',
            icon: 'i-ph-building-office',
            to: '/organizations',
          },
        ]
      : []),
  ],
  ...(config.value?.analyticsEngineAvailable
    ? [
        [
          {
            label: 'Analytics',
            icon: 'i-ph-chart-bar',
            to: '/analytics',
          },
        ],
      ]
    : []),
  [
    {
      label: 'Content Tools',
      icon: 'i-ph-wrench',
      children: [
        {
          label: 'Claims Testing',
          to: '/content-tools/claims-testing',
        },
        {
          label: 'Predicate Search',
          to: '/content-tools/predicate-search',
        },
        {
          label: 'Document Scoping',
          to: '/content-tools/scoping',
        },
        {
          label: 'Claims Finder',
          to: '/content-tools/claims-finder',
        },
        {
          label: 'Policy Builder',
          to: '/content-tools/policy-builder',
        },
      ],
    },
  ],
  [
    {
      label: 'APIs',
      icon: 'i-ph-atom',
      children: [
        {
          label: 'PaAPI',
          to: '/apis/paapi',
        },
      ],
    },
  ],

  /* LOCAL DEVELOPMENT ONLY */
  ...(import.meta.dev
    ? [
        [
          {
            label: 'Teams',
            icon: 'i-ph-users-four',
            children: [
              {
                label: 'Cloud',
                to: '/cloud',
              },
              {
                label: 'Core Claims',
                to: '/claims',
              },
              {
                label: 'Data',
                to: '/data',
              },
              {
                label: 'Engines',
                to: '/engines',
              },
              {
                label: 'Workflows',
                to: '/workflows',
              },
            ],
          },
        ],
        [
          {
            label: 'Releases',
            icon: 'i-ph-package',
            to: '/releases',
          },
        ],
      ]
    : []),
])
</script>

<template>
  <UNavigationMenu
    class="border-[var(--ui-border)] data-[orientation=horizontal]:border-b data-[orientation=vertical]:border-l"
    :items="items"
    highlight
    highlight-color="primary"
    orientation="vertical"
  />
</template>
